export default __webpack_public_path__ + "static/media/Hermes_pardini_Introv4.059357ce.mp4";